import graphql__bba85fa6fce389d28bcc from "./__generated__/ContactDataList_contact.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import UpdatePersonContactDialog from "./dialog/UpdatePersonContactDialog";
import UpdateTeamContactDialog from "./dialog/UpdateTeamContactDialog";
import SetContactPreferredLanguageDialog from "./dialog/SetContactPreferredLanguageDialog";
import {useFragment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/pro-light-svg-icons";

type Props = {
    queryRef: any
}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});


type ContactDataListProps = Props & ConnectedProps<typeof connector>;

const ContactDataList: React.FC<ContactDataListProps> = (props) => {
    const intl = useIntl();
    const contact = useFragment(
        graphql__bba85fa6fce389d28bcc
        , props.queryRef
    )

    const name = contact.teamName ? contact.teamName : contact.givenName + " " + contact.familyName;

    const {dispatchShowModal, dispatchHideModal} = props;
    const showUpdatePersonContactDialog = () => {
        dispatchShowModal({
            body: (<UpdatePersonContactDialog queryRef={contact} handleCloseDialog={dispatchHideModal}/>)
        })
    };

    const showUpdateTeamContactDialog = () => {
        dispatchShowModal({
            body: (<UpdateTeamContactDialog queryRef={contact} handleCloseDialog={dispatchHideModal}/>)
        })
    };

    const showSetPreferredLanguageDialog = () => {
        dispatchShowModal({
            body: (<SetContactPreferredLanguageDialog queryRef={contact} handleCloseDialog={dispatchHideModal}/>)
        })
    };

    const getLanguageDisplayName = (code: string | null): string => {
        if (!code) return '';
        const languageNames: Record<string, string> = {
            'de': intl.formatMessage({id: 'language.german', defaultMessage: 'Deutsch'}),
            'en': intl.formatMessage({id: 'language.english', defaultMessage: 'English'}),
        };
        return languageNames[code] || code;
    };

    return (
        <dl>
            {contact.__typename === 'PersonContact' && (
                <div
                    className="group py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 cursor-pointer hover:bg-gray-100"
                    onClick={showUpdatePersonContactDialog}
                >
                    <dt className="text-sm font-medium text-gray-500">
                        {intl.formatMessage({id: 'contact.salutation'})}
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <span className="grow">
                            {contact.salutation}
                        </span>
                        <span className="ml-4 shrink-0 invisible group-hover:visible">
                            <FontAwesomeIcon icon={faPencil}/>
                        </span>
                    </dd>
                </div>
            )}
            <div
                className={`py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 ${contact.__typename === 'PersonContact' ? '' : 'group cursor-pointer hover:bg-gray-100'}`}
                onClick={contact.__typename === 'TeamContact' ? showUpdateTeamContactDialog : undefined}
            >
                <dt className="text-sm font-medium text-gray-500">
                    {contact.__typename === 'TeamContact' ? intl.formatMessage({id: 'contact.teamName'}) : intl.formatMessage({id: 'view.contactData.name'})}
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span className="grow">{name}</span>
                    <span className="ml-4 shrink-0">
                        {contact.__typename === 'TeamContact' && (
                            <span className="invisible group-hover:visible">
                                <FontAwesomeIcon icon={faPencil}/>
                            </span>
                        )}
                    </span>
                </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
                <dt className="text-sm font-medium text-gray-500">
                    {intl.formatMessage({id: 'contact.emailAddress'})}
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span className="grow">
                        {contact.emailAddress}
                    </span>
                    <span className="ml-4 shrink-0"/>
                </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
                <dt className="text-sm font-medium text-gray-500">
                    {intl.formatMessage({id: 'contact.phoneNumber'})}
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span className="grow">
                        {contact.phoneNumber}
                    </span>
                </dd>
            </div>
            <div
                className="group py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 cursor-pointer hover:bg-gray-100"
                onClick={showSetPreferredLanguageDialog}
            >
                <dt className="text-sm font-medium text-gray-500">
                    {intl.formatMessage({id: 'contact.preferredLanguage'})}
                </dt>
                <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span className="grow">
                        {getLanguageDisplayName(contact.preferredLanguage)}
                    </span>
                    <span className="ml-4 shrink-0 invisible group-hover:visible">
                        <FontAwesomeIcon icon={faPencil}/>
                    </span>
                </dd>
            </div>
        </dl>
    )
}

export default connector(ContactDataList);
